


import { Routes, RouterModule } from '@angular/router';
import { BasePermissionComponent } from './basepermission.component';

const routes: Routes = [
    {
        path: '',
        component: BasePermissionComponent
    },
];

export const BasePermissionRoutes = RouterModule.forChild(routes);
